<template>
    <md-content class=" md-layout-item md-size-100 md-small-size-100">
    <div class="md-flex-center-center md-form-input md-relative">
        <md-toolbar class="md-toolbar md-table-toolbar md-transparent md-layout md-layout-item" md-elevation="0">
            <div class="md-toolbar-section-start">
                <h1 class="md-title md-subtitle">
                    {{ $t('views.order.preview.title') }} {{ order.orderType.name }}
                </h1>
            </div>
            <div class="md-toolbar-section-end">
                <span class="md-subtitle">{{ $t('views.order.preview.label.status') }} - {{ $t(`views.order.status.${order.status}`) }}</span>
                 <div class="zipButton" v-show="viewName === 'invoice'">
                    <div v-show="!isReadyToDownloadZip && !loading">
                        <md-button class="md-header-btn md-header-tab-btn" :disabled="ids.length == 0" @click="saveZip()">{{ $t('views.invoices.zip.saveZip') }}</md-button>
                    </div>
                    <div v-show="isReadyToDownloadZip && !loading">
                        <md-button class="md-header-btn md-header-tab-btn" :disabled="ids.length == 0" @click="downloadZip()">{{ $t('views.invoices.zip.downloadZip') }}</md-button>
                    </div>
                    <div v-show="loading">
                        <md-progress-spinner :md-diameter="50" :md-stroke="3" class="md-accent"
                            md-mode="indeterminate" />
                    </div>
                </div>
                <md-button class="md-button md-header-btn md-ml-30" to="/orders">
                    {{ $t('views.order.preview.back') }}
                </md-button>
            </div>
        </md-toolbar>
        <md-tabs ref="positions" md-alignment="left" class="md-tab-content-page orderPreviewBar" md-sync-route>
            <md-tab to="preview" v-if="hasAccess(viewAccess.preview)" id="tab-order-preview" :md-label="$t('views.order.preview.title')">
                <OrderPreview v-if="viewName === 'preview'" :order-id="orderId" :order-prop="order" />
            </md-tab>
            <md-tab to="invoice" v-if="hasAccess(viewAccess.invoice)" id="tab-invoices-list" :md-label="$t('views.order.preview.invoices')">
                <InvoicesList v-if="viewName === 'invoice'" :order-id="orderId" :show-tab="false" :invoices-tab="true"
                              :position="getPosition('invoice')" @addInvoicesIds="addInvoicesIds" />
            </md-tab>
            <md-tab to="contract" v-if="hasAccess(viewAccess.contract)" id="tab-contracts"
                    :md-label="$t('views.order.preview.contract')">
                <ContractsList v-if="viewName === 'contract'" :order-id="orderId" :position="getPosition('contract')" />
            </md-tab>
            <md-tab to="history" v-if="hasAccess(viewAccess.history)" id="tab-history" :md-label="$t('views.order.preview.history')">
                <OrderHistoryList v-if="viewName === 'history'" :order-id="orderId" :position="getPosition('history')" />
            </md-tab>
        </md-tabs>
         <div class="md-layout-item md-size-100 md-flex-right-align md-mt-30 custom-nav-button-style" v-if="hasAccess('PRIVILEGE_ORDER_CANCEL') && order.canDelete && checkUserType()">
                <md-button class="md-header-btn md-header-tab-btn md-ml-30" @click="cancelOrder()">Anuluj zlecenie</md-button>
            </div>
    </div>
    </md-content>
</template>

<script>
    import Vue from 'vue';
    import OrderPreview from "./OrderPreview";
    import InvoicesList from "@/views/invoices/list/InvoicesList";
    import ContractsList from "@/views/contracts/ContractsList";
    import {mapGetters} from "vuex";
    import {ordersEndpoint} from '@/services/adsign-backend/endpoints';
    import {invoicesEndpoint} from '@/services/adsign-backend/endpoints';
    import i18n from '@/i18n';
    import OrderHistoryList from '@/views/order/OrderHistoryList';
    import {orderViewAccess} from '@/config/accessConfig';
    import store from "@/store";

    export default {
        name: "Order",
        components: {OrderHistoryList, OrderPreview, InvoicesList, ContractsList},
        computed: {
            ...mapGetters('auth', ['hasAccess']),
            ...mapGetters('auth', ['userType'])
        },
        props:{
            orderId: {
                type: [Number, String],
                required: true
            },
            viewName: {
                type: String,
                default: undefined
            }
        },
        data: () => {
            return {
                viewAccess: orderViewAccess,
                activeTab: undefined,
                order: {},
                filterDataModel: [],
                ids: [],
                isReadyToDownloadZip: false,
                loading: false
            }
        },
        mounted() {
          ordersEndpoint.getOrder(this.orderId).then(result => {
            this.order = {
              ...result.data,
              priceMethod: result.data.budget ? 'budget' : 'grp'
            };
          }).catch(() => {
            store.commit('snackbar/SNACKBAR_TITLE', i18n.t("error.code.ORDER_NOT_FOUND"))
            store.commit('snackbar/SNACKBAR_SHOW', true)
          })
        },
        methods: {
          getPosition(tab){
            if(!this?.$refs?.positions?.MdTabs?.items){
              return null
            }
            let tabPositions = [];
            if(this.$refs.positions.MdTabs.items.hasOwnProperty('tab-order-preview') === true){
              tabPositions.push("preview")
            }
            if(this.$refs.positions.MdTabs.items.hasOwnProperty('tab-invoices-list') === true){
                tabPositions.push("invoice")
            }
            if(this.$refs.positions.MdTabs.items.hasOwnProperty('tab-contracts') === true){
              tabPositions.push("contract")
            }
            if(this.$refs.positions.MdTabs.items.hasOwnProperty('tab-history') === true){
              tabPositions.push("history")
            }
            return tabPositions.findIndex(item=>item === tab);
          },
            cancelOrder() {
                Vue.swal({
                title: i18n.t("views.orders.list.cancelOrder.title"),
                text: i18n.t("views.orders.list.cancelOrder.subtitle"),
                showCancelButton: true,
                confirmButtonColor: "#E51937",
                confirmButtonText: i18n.t("views.orders.list.cancelOrder.confirmButton"),
                cancelButtonText: i18n.t("views.orders.list.cancelOrder.cancelButton"),
                }).then((res) => {
                    if(res.value)
                        ordersEndpoint.cancelOrder(this.orderId).finally(() => {
                                this.$router.push('/orders')
                            })
                })
            },
            checkUserType(){
                if(this.userType === 'CLIENT_USER' || this.userType === 'CLIENT_ADMIN')
                    return true
                return false
            },
            addInvoicesIds(invoicesIds) {
                if(this.viewName === 'invoice') {
                    this.ids = invoicesIds;
                    this.loading = false;
                    this.isReadyToDownloadZip = false;
                }
            },
            saveZip() {
                this.loading = true;
                invoicesEndpoint.saveZipInvoices(this.ids)
                    .then( result => {
                        this.loading = false;
                        this.isReadyToDownloadZip = true;
                    })
            },
            downloadZip() {
                this.loading = true;
                invoicesEndpoint.getZipInvoices(this.ids)
                    .then( result => {
                        let blob = new Blob([result], { responseType: 'blob' })
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Compressed_Invoices.zip');
                        document.body.appendChild(link);
                        link.click();
                        this.loading = false;
                    })
            }
        }
    };
</script>

<style lang="scss" scoped>
    .tab-header {
        display: flex;
        flex-direction: column;
    }
    .orderPreviewBar{
        margin-top: 15px;
    }
    .custom-nav-button-style {
        height: 40px;
        position: absolute;
        top: 89px;
    }
    ::v-deep{
        .md-tabs-content{
            width: 100%;
            position: initial;
        }
        .md-header-btn:disabled {
            background: rgb(200, 200, 200);
            box-shadow: none;
            color: rgb(120, 120, 120) !important;
        }
    }
    .zipButton {
        margin-left: 20px;
    }
</style>
